let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("grfSI")).then(() => parcelRequire('1GtTj'));